export const deliveryPermissionData = {
  deliveryPermissionButtons: [
    {
      label: 'Yes',
      id: 'yes',
    },
    {
      label: 'No',
      id: 'no',
    },
  ],
  title:
    'Did you give your permission to leave the parcel in a specific location or with a neighbour?',
  image: {
    imgSrc:
      'https://media.product.which.co.uk/prod/images/original/82a41b02157d-tooliconlocationpin.jpg',
    imgAlt: '',
  },
}
